import { render } from "./Entidad.vue?vue&type=template&id=7251ace8&scoped=true"
import script from "./Entidad.vue?vue&type=script&lang=js"
export * from "./Entidad.vue?vue&type=script&lang=js"

import "./Entidad.vue?vue&type=style&index=0&id=7251ace8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7251ace8"]])

export default __exports__